import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {BehaviorSubject, timer} from "rxjs";
import {switchMap} from "rxjs/operators";
import {connect} from "react-redux";
import {getNotifications, rehydrateNotifications} from "../../actions/notifications";

class NotificationPoller extends Component {
  constructor(props) {
    super(props);
    this.initial = true;
  }

  handleRefresh = () => {
    // call the onRefresh callback if it is currently assigned as a prop
    const { onRefresh } = this.props;
    if (onRefresh) {
      const firstPull = this.initial;
      this.initial = false;
      onRefresh(firstPull);
    }
  };

  componentDidMount() {
    // set up the refresh callback, which will be called every 5 minutes or according to whatever interval is provided
    let { interval, onMount } = this.props;
    interval = interval || 60 * 1000;
    this.refresh = new BehaviorSubject(interval);
    this.refreshSub = this.refresh.pipe(
      switchMap(period => timer(0, period))
    ).subscribe(this.handleRefresh);
    onMount && onMount();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    // update the notification update interval if the props changed on the button
    if (this.props.interval !== prevProps.interval) {
      this.refresh.next(this.props.interval);
    }
  }

  componentWillUnmount() {
    // stop the refresh callback and clean up the subscription if the component is no longer rendered
    this.refreshSub.unsubscribe();
  }

  render() {
    return null;
  }
}

NotificationPoller.propTypes = {};

export default connect(
  (state, props) => ({
    interval: state.ui.notificationInterval
  }),
  (dispatch, props) => ({
    onRefresh: (isInitial) => dispatch(getNotifications(isInitial)),
    onMount: () => dispatch(rehydrateNotifications())
  })
)(NotificationPoller);



// WEBPACK FOOTER //
// ./src/components/Boilerplate/NotificationPoller.js